/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { editRoute, newRoute } from '../../shared/services/data.service';
import { LicenciamentoFormComponent } from "./licenciamento-form/licenciamento-form.component";
import { LicenciamentoListComponent } from "./licenciamento-list/licenciamento-list.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class LicenciamentosRoutingModule {}

export const licenciamentosRoutes: any[] = [
    {
        path: '',
        component: LicenciamentoListComponent
    },{
        path: editRoute + '/:id',
        component: LicenciamentoFormComponent
    },{
        path: newRoute,
        component: LicenciamentoFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/licenciamentos-routing.module.ts
 **/